<div class="form-group" *ngIf="checkViewMode('edit')">
  <label for="">
    <span class="red-text">{{ getTitle() }} </span>
    <span class="error-indication" *ngIf="isRequired()">{{getError()}}</span>
    <div *ngIf="getOptionByKey(attribute,'tooltip')" class="popover-info"
    [popover]="getOptionByKey(attribute,'tooltip')"
    placement="right"
    container="body"
    triggers="mouseenter:mouseleave">
      <i class="fa fa-question-circle"></i>
    </div>
  </label>
  <select
    class="form-control m-input"
    [class.has-error]="attribute.hasError"
    (change)="changedSelection()"
    [(ngModel)]="attribute.value"
    [tabindex]="getOptionByKey(attribute,'tabIndex')"
    [disabled]="getOptionByKey(attribute,'disabled', 'false')"
    [required]="getOptionByKey(attribute,'required', 'false')" >
    <option *ngIf="getOptionByKey(attribute,'placeholder')" value="null" disabled selected>
      {{getOptionByKey(attribute,'placeholder')}}
    </option>
    <option *ngFor="let option of getOptionAttributes()" value="{{option.value}}">{{ option.value }}</option>
  </select>
</div>
<div *ngIf="checkViewMode('view')" >
  <p><span>{{ getTitle() }}: </span> {{ attribute.value }}</p>
</div>
